import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useSelector, useDispatch } from "react-redux";
import { setSelectedTab } from "../../store/reducers/appSlice";
import { useUserInfo } from "../../hooks";
import NoMapViewCard from "../../components/noMapViewCard/NoMapViewCard";
import Overview from "../Overview/Overview";
import VenueEdit from "../../features/venueDetails/components";
import Loader from "../../components/loader";
import InternalToolsComponent from "../../features/internalToolsPage/components/InternalToolTabs";
import YourIndoorMap from "../../pages/YourIndoorMap/YourIndoorMap";
import MapDetails from "../../pages/MapDetails/MapDetails";
var FirstPage = function () {
    var dispatch = useDispatch();
    var selectedTab = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.app.selectedTab; });
    var isLoaded = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.app.isLoaded; });
    var venue = useSelector(function (state) { var _a; return (_a = state === null || state === void 0 ? void 0 : state.venue) === null || _a === void 0 ? void 0 : _a.venue; });
    var email = useUserInfo().email;
    var isInternalUser = email ? email.includes("@here.com") : false;
    return (_jsx(_Fragment, { children: isLoaded ? ((function () {
            switch (selectedTab) {
                case "overview":
                    return (venue === null || venue === void 0 ? void 0 : venue.id) ? _jsx(MapDetails, { venue: venue }) : _jsx(Overview, {});
                case "indoorMap":
                    return (venue === null || venue === void 0 ? void 0 : venue.id) ? (_jsx(MapDetails, { venue: venue })) : (_jsx(YourIndoorMap, {}));
                case "internalTools":
                    if (!isInternalUser) {
                        dispatch(setSelectedTab("overview"));
                    }
                    return (venue === null || venue === void 0 ? void 0 : venue.id) ? (_jsx(MapDetails, { venue: venue })) : (_jsx(InternalToolsComponent, {}));
                case "documentation":
                    return (_jsxs(_Fragment, { children: [dispatch(setSelectedTab("overview")), _jsx(Overview, {})] }));
                case "venueEdit":
                    return _jsx(VenueEdit, {});
                default:
                    return _jsx(NoMapViewCard, {});
            }
        })()) : (_jsx(Loader, {})) }));
};
export default FirstPage;
